// TASTE TEST — V0.2C Run 1 configuration.
// Working configuration defaults, NOT hardwired magic numbers.
// Layout variants (DUEL / SHOWDOWN) are presentation variants of the same
// KEEP ONE primitive and are switched here (and via the dev toolbar).

export const LAYOUT_VARIANTS = {
  DUEL: "duel", // two portrait artworks side-by-side
  SHOWDOWN: "showdown", // one artwork upper, one lower (9:16 capture)
};

export const appConfig = {
  // Default presentation variant on load (per Run 1 direction: DUEL).
  layoutVariant: LAYOUT_VARIANTS.DUEL,

  // Full 24-round fixture run.
  totalRounds: 24,

  // Initial public first-run lens policy: WORK vs WORK only.
  lensPolicy: "WORK_VS_WORK_ONLY",

  // Restrained motion timing (ms). Fast enough for serial play + screen capture.
  motion: {
    chosenMs: 260, // chosen candidate lock/intensify duration
    loseMs: 260, // losing candidate recede/fade duration
    advanceDelayMs: 360, // delay before the next pair arrives
  },

  // Hidden dev toggle (DUEL / SHOWDOWN layout, restart). Never shown in a
  // production build — auto-hidden unless running the dev server. Public beta
  // must expose no dev-looking chrome.
  showDevToolbar: true,
};
